import axios from "@/libs/axios";

export default {
    namespaced: true,
    state: {
        status: false,
        products: [],
        pagination: null,
        search: {},
    },
    getters: {
        _status(state) {
            return state.status
        },
        _products(state) {
            return state.products;
        },
        _search(state) {
            return state.search;
        },
        _pagination(state) {
            return state.pagination
        }
    },
    mutations: {
        setStatus(state, status) {
            state.status = status
        },
        setProducts(state, data) {
            state.products = data.content.data
            delete data.content.data;
            state.pagination = data.content;
        },
        setPagination(state, data) {
            delete data.data;
            state.pagination = data;
        },
        clearSearch(state) {
            return state.search = {}
        }
    },
    actions: {
        getProducts(context) {
            context.commit('setStatus', true)
            context.state.products = [];
            return axios.get('v2/trendyol/product', {params: context.state.search})
                .then(res => {
                    context.commit('setProducts', res.data)
                })
                .catch()
                .finally(() => {
                    context.commit('setStatus', false)
                })
        },
    }
}